/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ModalesHabitaciones from '../components/Modales/ModalesHabitaciones';
import Habitacion from '../models/Habitacion';
import { getHabitaciones } from '../services/HabitacionesService';

import './EstilosViews.scss';

type Props = {}

const habitaciones = (props: Props) => {

    var tituloSeccion: string = "Habitaciones";

    const [habitaciones, setHabitaciones] = useState<Habitacion[]>([]);

    useEffect(() => {
        setHabitaciones(getHabitaciones())
    }, []);

    const pintarItemHabitacion = () => {

        return habitaciones.map((habitacion: Habitacion, index: number) => {
            return (
                <div className="col-md-6 col-lg-4 mb-5" key={index}>
                        <div className="seccionBlanca-item mx-auto" data-bs-toggle="modal" data-bs-target={`#` + habitacion.idModal}>
                            <div className="seccionBlanca-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                <div className="seccionBlanca-item-caption-content text-center text-white">
                                    <i className="fas fa-plus fa-3x"></i>
                                </div>
                            </div>
                            <img className="img-fluid habitacion" src={ habitacion.imagenes[0].path } alt={habitacion.titulo} />
                            <p className='text-center fw-bolder mt-3'>
                                {habitacion.titulo}
                            </p>
                        </div>
                    </div>
            )
        })

    }

    return (
            
        <section className="page-section seccionBlanca" id="habitaciones">
            <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">{ tituloSeccion }</h2>
                
                <div className="divider-custom">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                        <i className="fa-solid fa-bed"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row justify-content-center">
                    {
                        pintarItemHabitacion()
                    }
                </div>
            </div>

            <ModalesHabitaciones habitaciones={habitaciones} />

        </section>

  )
}

export default habitaciones